/**
 * VSC reports dashboard section.
 */

import * as React from 'react';
import { useDetailsView } from '@/hooks/useDetailsView';
import { VscReportsDataTable } from '@/components/vsc-reports/VscReportsDataTable';
import type { ElementWidth } from '@/types/interface-elements.types';

/** Props for {@link VscReportsSection}. */
interface VscReportsSectionProps {
  layoutWidth?: ElementWidth;
}

/** Dashboard widget: VSC reports list. */
export const VscReportsSection: React.FC<VscReportsSectionProps> = ({ layoutWidth = 'full' }) => {
  const { openRowId, openRow, closeRow } = useDetailsView();

  return (
    <VscReportsDataTable
      expandedRowId={openRowId}
      onToggleRow={openRow}
      onCloseDetails={closeRow}
      layoutWidth={layoutWidth}
      isSection={true}
    />
  );
};
